
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`;

const DEPARTAMENTO_URL = `${API_BASE_URL}/Departamento/GetDepartamentosAsync`;
const LOCALIDAD_URL = `${API_BASE_URL}/Localidad/GetLocalidadesAsync`;


export {
    //DEPARTAMENTO
    DEPARTAMENTO_URL,

    //LOCALIDAD
    LOCALIDAD_URL,
}